import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useArticles } from "components/articles/hooks/useArticles";
import ArticleForm from "components/articles/ArticleForm";
import Toast from "components/Toast";

export default function EditArticle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadArticleById, editArticle } = useArticles();
  const [data, setData] = useState(null);
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    loadArticleById(id).then(setData);
  }, [id]);

  if (!data) return null;

  return (
    <>
      <ArticleForm
        initialData={data?.data}
        onSubmit={async (fd) => {
          await editArticle(id, fd);
          setToast({
            open: true,
            title: "Updated Successfully!",
            message: "Article has been updated successfully.",
            type: "success",
          });
          // navigate("/admin/articles");
        }}
        onBack={() => navigate(-1)}
      />
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1000}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          // 3. Navigate after toast closes/timer finishes
          navigate("/admin/articles");
        }}
      />
    </>
  );
}
